<template>
  <div class="app-container">
    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="bgk-img" :class="{ 'is-fallback': bannerLoadFailed }">
        <img
          v-if="!bannerLoadFailed"
          src="https://www.hketang.cn/_nuxt/img/course-banner.2811f9b.png"
          alt="作品展示"
          @error="handleBannerError"
        />
        <div class="banner-overlay">
          <div class="banner-content">
            <div class="banner-title">学员优秀作品 （奖学金获得者）</div>
            <div class="banner-subtitle">展示最前沿的平面设计、插画设计实战成果</div>
          </div>
        </div>
      </div>
      <div class="tabs-box">
        <div class="tabs">
          <div
            class="left"
            @click="tabschange(1)"
            :class="tabsactive == 1 ? 'active' : ''"
          >
            平面设计
          </div>
          <div
            class="right"
            @click="tabschange(2)"
            :class="tabsactive == 2 ? 'active' : ''"
          >
            插画设计
          </div>
        </div>
        <div class="listbox">
          <div
            class="card"
            v-for="(item, i) in workslist"
            :key="i"
            @click="handledetal(item)"
          >
            <img :src="item.pictureUrl" alt="" />
            <div class="info-box">
              <div class="name" :title="item.title">{{ item.title }}</div>
              <div class="content" :title="stripHtml(item.content)">{{ stripHtml(item.content) }}</div>
              <div class="meta">
                <span class="student">{{ item.studentName || '佚名' }}</span>
                <span class="class-name">{{ item.className || '未知班级' }}</span>
              </div>
            </div>
          </div>
          <div style="width: 268px"></div>
          <div style="width: 268px"></div>
          <div style="width: 268px"></div>
          <el-pagination
            style="text-align: right"
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="pageSize"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <indetails
        :dialogTableVisible.sync="dialogTableVisible"
        :id="selectedId"
      ></indetails>
    </div>
  </div>
</template>

<script>
import { getworks } from "@/api/index.js";
import indetails from "./details.vue";

export default {
  name: "production",
  components: { indetails },
  data() {
    return {
      bannerLoadFailed: false,
      tabsactive: 1,
      currentPage: 1,
      pageSize: 12,
      total: 0,
      workslist: [],
      dialogTableVisible: false,
      selectedId: null,
    };
  },
  created() {
    this.getworks();
  },
  methods: {
    stripHtml(html) {
      if (!html) return '暂无描述';
      return html.replace(/<[^>]+>/g, '').replace(/&nbsp;/ig, ' ');
    },
    handleBannerError() {
      this.bannerLoadFailed = true;
    },
    tabschange(val) {
      this.tabsactive = val;
      this.currentPage = 1; // 切换类型时重置页码
      this.getworks();
    },
    getworks() {
      // 作品类型映射：1-平面设计(0), 2-插画设计(1)
      let worksTypeMap = {
        1: "1", // 平面设计
        2: "2", // 插画设计
      };
      
      getworks({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        worksType: worksTypeMap[this.tabsactive],
      }).then((res) => {
        if (res.data && res.data.list) {
          this.workslist = res.data.list;
          this.total = res.data.total || 0;
        } else {
          this.workslist = [];
          this.total = 0;
        }
      }).catch(error => {
        console.error('获取作品失败:', error);
        this.workslist = [];
        this.total = 0;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 改变页面大小时重置页码
      this.getworks();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getworks();
    },
    handledetal(val) {
      this.selectedId = val.id;
      this.dialogTableVisible = true;
    }
  },
};
</script>

<style scoped lang="scss">
.app-container {
  padding: 0;
  margin: 0;
  font-family: "Microsoft YaHei";

  color: #333;
  overflow: hidden;
  clear: both;
  .main-content {
      .bgk-img {
      width: 100%;
      height: 210px;
      z-index: 2;
      position: relative;
      background: linear-gradient(135deg, #eef4ff 0%, #f9fbff 55%, #e6eefc 100%);
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.is-fallback {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .banner-overlay {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
      }
      .banner-content {
        text-align: left;
        padding-left: 40px;
      }
      .banner-title {
        font-size: 38px;
        font-weight: bold;
        color: #333;
        margin-bottom: 12px;
        text-shadow: 0 2px 4px rgba(255, 255, 255, 0.8);
      }
      .banner-subtitle {
        font-size: 18px;
        color: #666;
        letter-spacing: 2px;
      }
    }
      .tabs-box {
      width: 100%;
      font-size: 18px;
      background-color: #f5f6f9;
      padding: 0 0 60px 0;
      position: relative;
      .tabs {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        margin-top: -20px;
        background-color: #f5f6f9;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        position: relative;
        z-index: 10;

        .left, .right {
          flex: 1;
          height: 74px;
          background: transparent;
          font-weight: 500;
          color: #2d3341;
          line-height: 74px;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          z-index: 1;
          text-align: center;
          &:hover {
            color: #d5182f;
          }
        }
        .left {
          border-top-left-radius: 20px;
        }
        .right {
          border-top-right-radius: 20px;
        }
        .active {
          background: #fff;
          height: 74px;
          line-height: 74px;
          margin-top: 0;
          border-top-right-radius: 20px;
          border-top-left-radius: 20px;
          color: #d5182f;
          font-weight: 700;
          z-index: 2;
          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 40px;
            height: 3px;
            background-color: #d5182f;
            border-radius: 2px;
          }
        }
      }
      .listbox {
        width: 1200px;
        margin: 0 auto;
        background: #fff;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 30px;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
        .card {
          width: 268px;
          border-radius: 10px;
          overflow: hidden;
          border: 1px solid #ebeef5;
          margin-bottom: 35px;
          cursor: pointer;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
          img {
            width: 268px;
            height: 180px;
            object-fit: cover;
          }

          .info-box {
            padding: 15px 12px;

            .name {
              font-size: 16px;
              font-family: "Microsoft YaHei";
              font-weight: 600;
              color: #303133;
              margin: 0 0 8px;
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .content {
              font-size: 14px;
              color: #606266;
              margin: 0 0 16px;
              font-family: "Microsoft YaHei";
              text-align: left;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              line-height: 1.5;
              height: 42px;
            }

            .meta {
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: 13px;
              color: #909399;
              font-family: "Microsoft YaHei";
              border-top: 1px solid #f0f2f5;
              padding-top: 10px;

              .student {
                font-weight: 500;
                color: #d5182f;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 45%;
              }

              .class-name {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 50%;
                text-align: right;
              }
            }
          }
          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
            border-color: transparent;
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .app-container .main-content .tabs-box .tabs {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
  }
  .app-container .main-content .tabs-box .listbox {
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
  }
}

@media (max-width: 992px) {
  .app-container .main-content .tabs-box .tabs .left,
  .app-container .main-content .tabs-box .tabs .right {
    width: 50%;
  }
  .app-container .main-content .tabs-box .listbox .card {
    width: calc(50% - 8px);
  }
  .app-container .main-content .tabs-box .listbox .card img {
    width: 100%;
    height: auto;
  }
  /* 隐藏用于占位的固定宽度列，避免移动端产生横向滚动 */
  .app-container .main-content .tabs-box .listbox > div[style*="width: 268px"] {
    display: none !important;
  }
}

@media (max-width: 600px) {
  .app-container .main-content .tabs-box .listbox {
    padding: 12px;
  }
  .app-container .main-content .tabs-box .listbox .card {
    width: 100%;
  }
}
</style>
